module.exports = __webpack_public_path__ + "static/img/ppjzpj.b4154679.png";